import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Selectable, SelectEventListener } from '@philips-emr/tws-core/lib/component/types';

export interface HpmsAttachmentsListItem {
  label: string;
  value: string;
}

class HpmsAttachmentsListAPI extends ComponentAPI<{ data: HpmsAttachmentsListItem[] }> implements Selectable<HpmsAttachmentsListItem> {
  /** @event */
  @AwesomeEvent
  onSelect = new SelectEventListener<HpmsAttachmentsListItem>();

  setData(data: HpmsAttachmentsListItem[]): void {
    this.setState({ data });
  }
}

export default HpmsAttachmentsListAPI;
